import { api } from "./api.ts";

export type PurchaseView = {
  id: string;
  role: "buyer" | "seller";
  status: "pending_contact" | "contact_shared" | "completed" | "cancelled";
  quantity: number;
  unit_price: number;
  total: number;
  created_at: number;
  contact_share_deadline: number;
  contact_shared_at: number | null;
  done_marked_by: "me" | "other" | null;
  done_marked_at: number | null;
  completed_at: number | null;
  completed_via: string | null;
  cancelled_at: number | null;
  cancelled_by: string | null;
  cancel_reason: string | null;
  problem_open: boolean;
  problem: Record<string, unknown> | null;
  deal_code: string | null;
  deal_code_locked_until: number | null;
  listing: { id: string; title: string; status: string; cover: string | null } | null;
  seller: {
    handle: string;
    display_name: string;
    phone: string | null;
    median_share_s: number | null;
  };
  buyer: {
    handle: string;
    display_name: string;
    phone: string | null;
    city: { name_vi: string; name_en: string } | null;
    district: string | null;
    completed_purchases: number;
    no_shows_90d: number;
    line: "new" | "reliable" | "noshows";
  };
  server_ts: number;
};

export type PurchaseListItem = {
  id: string;
  status: PurchaseView["status"];
  quantity: number;
  total: number;
  problem_open: boolean;
  created_at: number;
  title: string;
  cover: string | null;
  buyer_handle: string;
  seller_handle: string;
};

export const loadPurchase = (id: string) => api<PurchaseView>(`/api/purchases/${id}`);
export const act = (id: string, action: "share" | "cancel" | "done" | "confirm") =>
  api<PurchaseView>(`/api/purchases/${id}/${action}`, { body: {} });
export const enterCode = (id: string, code: string) =>
  api<PurchaseView>(`/api/purchases/${id}/deal-code`, { body: { code } });
export const buy = (listingId: string, quantity: number, idempotency_key: string) =>
  api<PurchaseView>(`/api/listings/${listingId}/buy`, { body: { quantity, idempotency_key } });
export const listPurchases = (kind: "purchases" | "sales", status?: string) =>
  api<{ items: PurchaseListItem[]; server_ts: number }>(
    `/api/me/${kind}${status ? `?status=${status}` : ""}`,
  );
